export default {
  /* Global application actions */
  LOGOUT: 'LOGOUT',

  /* Modal related */
  SHOW_MODAL: 'SHOW_MODAL',
  HIDE_MODAL: 'HIDE_MODAL',

  /* Sidemenu related */
  SHOW_SIDEMENU: 'SHOW_SIDEMENU',
  HIDE_SIDEMENU: 'HIDE_SIDEMENU',
  INIT_SIDEMENU: 'INIT_SIDEMENU',
  TOGGLE_SIDEMENU: 'TOGGLE_SIDEMENU',

  /* Tour Wizard related */
  NEXT_STEP_TOUR_WIZARD: 'NEXT_STEP_TOUR_WIZARD',
  PREV_STEP_TOUR_WIZARD: 'PREV_STEP_TOUR_WIZARD',
  UNBIND_TOUR_WIZARD_CALLBACKS: 'UNBIND_TOUR_WIZARD_CALLBACKS',

  /* Photo Upload */
  INIT_UPLOADER: 'INIT_UPLOADER',
  STORE_UPLOADER: 'STORE_UPLOADER',

  // Photo
  REMOVE_PHOTO: 'REMOVE_PHOTO',
  REMOVE_PHOTO_COMPLETED: 'REMOVE_PHOTO_COMPLETED',
  REMOVE_PHOTO_FAILED: 'REMOVE_PHOTO_FAILED',

  /* Titlebar */
  INIT_TITLEBAR: 'INIT_TITLEBAR',
  UPDATE_TITLEBAR: 'UPDATE_TITLEBAR',
  ATTACH_CONTROL_TITLEBAR: 'ATTACH_CONTROL_TITLEBAR',
  DEATTACH_CONTROL_TITLEBAR: 'DEATTACH_CONTROL_TITLEBAR',
  SET_SAVEABLE_TITLEBAR: 'SET_SAVEABLES_TITLEBAR',
  UNSET_SAVEABLES_TITLEBAR: 'UNSET_SAVEABLES_TITLEBAR',
  OVERRIDE_TITLEBAR: 'OVERRIDE_TITLEBAR',

  /* Onboarding */
  UPDATE_PROGRESS: 'UPDATE_PROGRESS',
  UPDATE_PROGRESS_COMPLETED: 'UPDATE_PROGRESS_COMPLETED',
  UPDATE_PROGRESS_FAILED: 'UPDATE_PROGRESS_FAILED',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  COMPLETE_ONBOARDING_COMPLETED: 'COMPLETE_ONBOARDING_COMPLETED',

  /* Notification */
  REGISTER_NOTIFICATION: 'REGISTER_NOTIFICATION',
  UPDATE_NOTIFICATION: 'UPDATE_NOTIFICATION',
  SHOW_NOTIFICATION: 'SHOW_NOTIFICATION',
  HIDE_NOTIFICATION: 'HIDE_NOTIFICATION',
  ACTIVATE_NOTIFICATION: 'ACTIVATE_NOTIFICATION',
  DEACTIVATE_NOTIFICATION: 'DEACTIVATE_NOTIFICATION',
  FLASH_NOTIFICATION: 'FLASH_NOTIFICATION',

  /* User Overview */
  UPDATE_USER_OVERVIEW: 'UPDATE_USER_OVERVIEW',
};
